<template>
    <div class="home">
      <div class="container">
        <div class="columns is-centered">
          <div class="column">
            <ValidationObserver v-slot="{ errors }" tag="div">
            <input-form
              ref="form"
              :errors="errors"
              name="SiteInformation"
              @submit.prevent="nextPage"
            >
                <div class="content">
                    <h1>Site Information</h1>
                    <h2>Address</h2>
                    <div class="columns">
                    <div class="column">
                      <textbox
                        id="ais-address"
                        v-model="currSite.RawAddress"
                        name="txt-tenant-address-search"
                        placeholder="Search for a City of Philadelphia Street Address..."
                        list.native="addressCandidateList"
                        @input="getAddressCandidatesFromAis()"
                        @keydown.enter.prevent=""
                      />
                    </div>
                  </div>
                    <div class="columns">
                    <div class="column">
                      <div
                        v-show="ShowCandidateTable"
                        class="table-container"
                      >
                        <div v-if="AddressCandidatesLoaded">
                          <h4
                            v-if="
                              currSite.Candidates
                                .length > 1
                            "
                          >
                            We've found multiple addresses like that, please
                            select yours from the list below, or add more
                            information to the search above to narrow your
                            results
                          </h4>
                          <h4 v-else>
                            We've found a property like the one you entered
                            above, please select it from below to auto populate
                            the address fields. Please fill in the
                            apartment / unit number below if
                            applicable.
                          </h4>
                          <table>
                            <thead>
                              <tr>
                                <th>Address</th>
                                <th>ZIP Code</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="item in currSite.Candidates"
                                :key="item.id"
                              >
                                <td>
                                  <input
                                    :id="`candidate-${item.id}`"
                                    :value="item.selected"
                                    type="radio"
                                    name="selectedCandidate"
                                    @click="setSelectedAddressCandidate(item)"
                                  >
                                  <label
                                    class="address-label"
                                    :for="`candidate-${item.id}`"
                                  >{{ item.StreetAddress }}</label>
                                </td>
                                <td>{{ item.ZipCode }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-else>
                          <span>Loading...</span>
                        </div>
                      </div>
                      <div
                        v-if="AddressCandidatesNotFound"
                      >
                        <span>No Address Found. Please Enter Manually.</span>
                      </div>
                    </div>
                  </div>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                            v-model="currSite.Street1"
                            error="This field is required"
                            id="input-site-address-street1"
                            name="input-site-address-street1"
                            readonly
                            required
                            rules="required"
                            placeholder="Address"
                            type="text"
                            />
                        </div>
                        <div class="column">
                            <vee-textbox
                            v-model="currSite.Street2"
                            error="This field is required"
                            name="input-site-address-street2"
                            placeholder="Apt / Unit"
                            type="text"
                            />
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                            v-model="currSite.City"
                            error="This field is required"
                            name="input-site-address-city"
                            readonly
                            :disabled="true"
                            required
                            rules="required"
                            placeholder="City"
                            type="text"
                            />
                        </div>
                        <div class="column">
                            <vee-dropdown
                            v-model="currSite.State"
                            :options="States"
                            error="This field is required"
                            name="input-site-address-state"
                            readonly
                            :disabled="true"
                            required
                            rules="required"
                            placeholder="State"
                            type="text"
                            />
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                            v-model="currSite.Zip"
                            id="input-site-address-zip"
                            error="This field is required"
                            name="input-site-address-zip"
                            readonly
                            required
                            rules="required"
                            placeholder="Zip"
                            type="text"
                            />
                        </div>
                        <div class="column">
                            <vee-textbox
                            v-model="currSite.Country"
                            error="This field is required"
                            name="input-site-address-country"
                            readonly
                            :disabled="true"
                            required
                            rules="required"
                            placeholder="Country"
                            type="text"
                            />
                        </div>
                    </div>
                    <h2>Site Details</h2>
                    <div class="columns">
                        <!-- <div v-if="showOwner" class="column">
                            <vee-textbox
                            v-model="currSite.Owner"
                            error="This field is required"
                            id="input-site-owner"
                            name="input-site-owner"
                            readonly
                            :disabled="true"
                            required
                            rules="required"
                            placeholder="Owner"
                            type="text"
                            />
                        </div> -->
                        <div class="column">
                            <vee-dropdown
                            v-model="currSite.LotStructure"
                            :options="lotStructure"
                            error="This field is required"
                            name="input-site-lot-structure"
                            required
                            rules="required"
                            placeholder="Lot/Structure"
                            type="text"
                            />
                        </div>
                    </div>
                    <!-- <div class="columns">
                        <div class="column">
                            <vee-textbox
                            v-model="currSite.CouncilDistrict"
                            error="This field is required"
                            name="input-site-council-district"
                            readonly
                            :disabled="true"
                            required
                            rules="required"
                            placeholder="Council District"
                            type="text"
                            />
                        </div>
                        <div class="column">
                            <vee-textbox
                            v-model="currSite.CensusTract"
                            error="This field is required"
                            name="input-site-census-tract"
                            readonly
                            :disabled="true"
                            required
                            rules="required"
                            placeholder="Census Tract"
                            type="text"
                            />
                        </div>
                    </div> -->
                    <div class="columns">
                        <div class="column">
                            <vee-dropdown
                            v-model="currSite.AcqMethod"
                            :options="acqMethod"
                            error="This field is required"
                            name="input-site-acq-method"
                            required
                            rules="required"
                            placeholder="Acquisition Method"
                            type="text"
                            />
                        </div>
                    </div>
                    <div class="columns" v-if="currSite.AcqMethod == 'Other'">
                        <div class="column">
                            <vee-textarea
                            v-model="currSite.OtherAcqMethod"
                            error="This field is required"
                            name="input-site-other-acq-method"
                            required
                            rules="required"
                            placeholder="Please specify other acquisition method"
                            type="text"
                            />
                        </div>

                    </div>
                    <div class="columns">
                  <div v-if="FullSummaryApplication.Sites.length > 1" class="column" style="text-align: left;">
                      <button
                      type="button"
                      class="button is-danger"
                      @click="removeSite(siteId, FullSummaryApplication.Sites)"
                      >
                      Remove Site
                      </button>
                  </div>
                  <div v-if="FullSummaryApplication.Sites.length == siteId" class="column" style="text-align: right;">
                      <button
                      type="button"
                      class="button is-success"
                      @click="addSite"
                      >
                      Add Site
                      </button>
                  </div>
              </div>
                    <div class="columns">
                  <div v-if="Number(siteId) == 1" class="column" style="text-align: left;">
                      <button
                      type="button"
                      class="button is-primary"
                      @click="prevPage"
                      >
                      Back
                      </button>
                  </div>
                  <div v-if="Number(siteId) > 1" class="column" style="text-align: start;">
                      <button
                      type="button"
                      class="button is-primary"
                      @click="previousSite"
                      >
                    Back
                    </button>
                  </div>
                  <div v-if="FullSummaryApplication.Sites.length <= Number(siteId)" class="column" style="text-align: right;">
                      <button
                      type="button"
                      class="button is-primary"
                      @click="nextPage"
                      >
                      Next
                      </button>
                  </div>
                  <div v-if="FullSummaryApplication.Sites.length > Number(siteId)" class="column" style="text-align: end;">
                      <button
                      type="button"
                      class="button is-primary"
                      @click="nextSite"
                      >
                        Next
                    </button>
                  </div>
              </div>
                </div>
            </input-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import { getPropertyValueOrDefault } from "@/utilities/functions.js";
// import buildPropertyInfoObject from "@/utilities/get-property-info-object.js";
// import axios from "axios";
import options from "@/utilities/options";
import SiteInformation from "@/utilities/classes/site-information";
import { delay } from "@/utilities/functions";
import axios from "axios";

export default {
  name: 'SiteInformation',
  mixins: [options],
  props: {
    siteId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      FullSummaryApplication: null,
      currSite: null,
      AddressCandidatesLoaded: null,
      AddressCandidatesNotFound: null,
      showOwner: false,
    };
  },
  async beforeMount(){
    window.scrollTo(0, 0);
    this.FullSummaryApplication = await this.$vlf.getItem('fullSummaryApplication');
    if(this.FullSummaryApplication.Sites.length < this.siteId){
        const site = new SiteInformation(Number(this.siteId));
        this.FullSummaryApplication.Sites.push(site);
    }
    this.currSite = this.FullSummaryApplication.Sites[this.siteId - 1];
    this.currSite.Country = "United States";
  },
  methods: {
    async nextPage(){
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            
            this.$router.push({
                name: "UnitDetails",
            });
        }
    },
    async removeSite(siteId, siteArray){
        this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;
        if(siteArray.length == 1){
            alert("Must have at least 1 site.");
            this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
        }
        else{
            siteArray.splice(siteId - 1, 1);

            for(var i = siteId - 1; i < siteArray.length; i++){
                siteArray[i].id = siteArray[i].id - 1;
            }

            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
        
            this.currSite = this.FullSummaryApplication.Sites[this.siteId - 2];
            if(siteId > 1){
                this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
                window.scrollTo(0, 0);
                this.$router.push({
                name: "SiteInformation",
                params: { siteId: Number(this.siteId) - 1  },
                });
                location.reload();
            } else{
                this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
                window.scrollTo(0, 0);
                location.reload();
            }
        }
    },
    async addSite(){
        const isInputValid = await this.$refs.form.$parent.validate();
          if (isInputValid) {
            this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            const site = new SiteInformation(Number(this.siteId) + 1);
            this.FullSummaryApplication.Sites.push(site);
            this.currSite = this.FullSummaryApplication.Sites[this.siteId];
            this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
            window.scrollTo(0, 0);
            this.$router.push({
                name: "SiteInformation",
                params: { siteId: Number(this.siteId) + 1  },
            });
            location.reload();
        }
    },
    async prevPage(){
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.$vlf.removeItem('fullSummaryApplication');
          await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            
            this.$router.push({
                name: "ProjectTeam",
            });
        }
    },
    async previousSite(){
        const isInputValid = await this.$refs.form.$parent.validate();
          if (isInputValid) {
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            window.scrollTo(0, 0);
            this.currSite = this.FullSummaryApplication.Sites[this.siteId - 2];
            this.$router.push({
                name: "SiteInformation",
                params: { siteId: Number(this.siteId) - 1  },
            });
        }
    },
    async nextSite(){
        const isInputValid = await this.$refs.form.$parent.validate();
          if (isInputValid) {
            this.currSite = this.FullSummaryApplication.Sites[this.siteId];
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            window.scrollTo(0, 0);
            this.$router.push({
                name: "SiteInformation",
                params: { siteId: Number(this.siteId) + 1  },
            });
        }
    },
    getAddressCandidatesFromAis() {
      var vData = this;
      vData.AddressCandidatesLoaded = false;
      vData.ShowCandidateTable = true;

      const aisUrl = `https://api.phila.gov/ais/v1/search/${this.currSite.RawAddress}?gatekeeperKey=2d130e3603f8931d82d39b3913bffe18`;
      delay(() => {
        axios.get(aisUrl).then((result) => {
          if (result && result.data) {
            this.currSite.Candidates = result.data.features.map(
              (i, idx) => ({
                id: idx,
                StreetAddress: i.properties.street_address,
                ZipCode: i.properties.zip_code,
                opaNumber: i.properties.opa_account_num,
                opaOwner: i.properties.opa_owners,
                dorNumber: i.properties.dor_parcel_id,
                pwdNumber: i.properties.pwd_parcel_id,
                councilDistrict: i.properties.council_district_2024,
                censusTract: i.properties.census_tract_2020,
                selected: false,
              }),
            );
            vData.AddressCandidatesLoaded = true;
          } else {
            vData.ShowCandidateTable = false;
            this.currSite.Candidates = [];
            this.currSite.Street1 = "";
            this.currSite.Zip = "";
          }
        }).catch(() => {
          vData.ShowCandidateTable = false;
          document.getElementById("tb-input-site-address-street1").removeAttribute("readonly");
          document.getElementById("tb-input-site-address-zip").removeAttribute("readonly");
          //document.getElementById("tb-input-site-owner").removeAttribute("readonly");
          this.currSite.Candidates = [];
          this.currSite.Street1 = "";
          this.currSite.Zip = "";
        });
      }, 1000);
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    setSelectedAddressCandidate(item) {
      this.currSite.Street1 = item.StreetAddress;
      this.currSite.Zip = item.ZipCode;
      this.currSite.CouncilDistrict = item.councilDistrict;
      this.currSite.CensusTract = item.censusTract;
      this.currSite.Owner = item.opaOwner;
      this.currSite.DORNumber = item.dorNumber;
      this.currSite.OPANumber = item.opaNumber;
      // if(this.currSite.Owner == "" || this.currSite.Owner == null){
      //     this.showOwner = true;
      //     this.sleep(10000);
      //     document.getElementById("tb-input-site-owner").removeAttribute("readonly");
      // }
    },
  }
};
</script>